(function () {
  'use strict';
  var SY = '£';

  /* Normalize a price string */
  function normalize(text) {
    if (!text) return text;
    var t = String(text).trim();
    // Ensure leading £ exactly once
    if (!t.startsWith(SY)) t = SY + t;
    // £From -> From £
    t = t.replace(/^\s*£\s*From\s*/i, 'From £');
    // Tighten space after £
    t = t.replace(/£\s+(\d)/g, '£$1');
    return t;
  }

  /* Wrap Shopify formatters so dynamic updates carry £ */
  function wrapFormatMoney() {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var orig = Shopify.formatMoney;
      Shopify.formatMoney = function () {
        var out = orig.apply(this, arguments);
        return normalize(out);
      };
    }
    if (
      window.theme &&
      window.theme.Shopify &&
      typeof window.theme.Shopify.formatMoney === 'function'
    ) {
      var o2 = window.theme.Shopify.formatMoney;
      window.theme.Shopify.formatMoney = function () {
        var out = o2.apply(this, arguments);
        return normalize(out);
      };
    }
  }

  /* Detect if a concrete variant was selected inside this product card */
  function variantSelectedFor(el) {
    var card = el.closest(
      '.card, .product-card, .grid__item, .product-item, .product-card-wrapper, .cc-product-card'
    );
    if (!card) return false;
    var sel = card.querySelector('select');
    if (sel && sel.selectedIndex > 0) return true;
    if (
      card.querySelector(
        '[data-variant-id],[data-selected-variant],[data-variant]'
      )
    )
      return true;
    return false;
  }

  /* Only act on text-bearing leaf nodes, never on structural containers */
  var TARGET_SELECTOR = [
    '.money',
    '.theme-money',
    '.price-item',
    '.price-item--regular',
    '.price-item--sale',
    '.price__current',
    '[data-money]',
    '[data-price-value]',
  ].join(',');

  function shouldSkipFormatting(el) {
    if (!el) return true;
    if (el.closest('[data-prevent-money-formatting]')) return true;
    return false;
  }

  function isTextBearing(el) {
    // skip if element has nested elements and is not a known money span
    if (
      el.children &&
      el.children.length > 0 &&
      !el.matches('.money,.theme-money')
    )
      return false;
    return true;
  }

  function formatPriceElement(el) {
    if (!el || shouldSkipFormatting(el) || !isTextBearing(el)) return;
    var txt = (el.textContent || '').trim();
    if (!txt || !/\d/.test(txt)) return; // must contain digits
    var newTxt = normalize(txt);
    // Remove "From" once a specific variant is selected
    if (/^From\s+£/i.test(newTxt) && variantSelectedFor(el)) {
      newTxt = newTxt.replace(/^From\s+£/i, '£');
    }
    // Cache to avoid churn
    var last = el.getAttribute('data-pnm-last') || '';
    if (newTxt !== last) {
      el.textContent = newTxt;
      el.setAttribute('data-pnm-last', newTxt);
    }
  }

  function scan() {
    document.querySelectorAll(TARGET_SELECTOR).forEach(formatPriceElement);
  }

  function init() {
    wrapFormatMoney();
    scan();
    // Observer, batched
    var rafPending = false;
    var mo = new MutationObserver(function () {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () {
        rafPending = false;
        scan();
      });
    });
    mo.observe(document.documentElement, {
      subtree: true,
      childList: true,
      characterData: true,
    });
    // Common price change triggers
    document.addEventListener(
      'change',
      function (e) {
        if (e.target && e.target.matches('select, [name*=variant]')) scan();
      },
      true
    );
    document.addEventListener('variant:change', scan, true);
    document.addEventListener('price:update', scan, true);
    // Light periodic safety net
    setInterval(scan, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Fix047 DOM Walker */
(function () {
  'use strict';
  var SY = '';

  /* Walk text nodes under a root and normalize price strings */
  function walkAndFix(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue) return NodeFilter.FILTER_REJECT;
        var t = node.nodeValue.trim();
        // Must contain digits and not already start with £
        if (!/\d/.test(t)) return NodeFilter.FILTER_REJECT;
        // Avoid meta/template/script/style or skipped containers
        var p = node.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        if (p.closest('script,style,meta,link,template'))
          return NodeFilter.FILTER_REJECT;
        if (p.closest('[data-prevent-money-formatting]'))
          return NodeFilter.FILTER_REJECT;
        // Only inside common price containers
        if (
          !p.closest(
            '.price, .price-item, .price__current, .price-item--regular, .price-item--sale, .card-information__price, .product-price, .money, .theme-money, [data-price], [data-price-value], .cc-product-card, .product-card, .grid__item, .recommendations, .related-products'
          )
        ) {
          return NodeFilter.FILTER_SKIP;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    });
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) {
      nodes.push(n);
    }
    nodes.forEach(function (node) {
      var txt = node.nodeValue;
      if (/^\s*£/.test(txt)) return;
      // Tighten spacing when we prefix
      txt = txt.replace(/^\s+/, '');
      node.nodeValue = SY + txt.replace(/£\s+(\d)/g, '£$1');
    });
  }

  /* Batch updates */
  var rafPending = false;
  function rescan() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      walkAndFix(document.body);
    });
  }

  /* Init */
  function initWalker() {
    walkAndFix(document.body);
    var mo = new MutationObserver(function () {
      rescan();
    });
    mo.observe(document.documentElement, {
      subtree: true,
      childList: true,
      characterData: true,
    });
    // Safety net
    setInterval(rescan, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWalker);
  } else {
    initWalker();
  }
})();
